<template>
  <div class="pad-bot30 backwihte width100 margin-auto">
    <div class="stewardbox">
      <!-- <p class="stewardtitle">软著版权</p> -->
      <div class="textalign-left pad-bot10 f16">软著版权申请</div>
      <div class="patentapp">
        <p class="width90 margin-auto margin-top10 pad-top20">专利类型</p>
        <el-radio-group
          v-model="radio"
          @change="onchange"
          class="radiogroup"
          v-for="(item, index) in table"
          :key="index"
        >
          <el-radio :label="index">{{ item.name }}</el-radio>
        </el-radio-group>
        <div class="inputbox">
          <div>
            <p class="margin-top10">软著名称</p>
            <el-input
              placeholder="请输入软著名称"
              v-model="patent"
              clearable
              class="input"
            >
            </el-input>
          </div>

          <div>
            <p class="margin-top10">计划申请时间</p>
            <el-date-picker
              class="input datepic"
              v-model="apply_date"
              type="date"
              placeholder="计划申请时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>

          <div>
            <p class="margin-top10">联系人</p>
            <el-input
              placeholder="请输入联系人"
              v-model="contact"
              clearable
              class="input"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="margin-top20 textalign-right">
        <el-button @click="dialognull()">取 消</el-button>
        <el-button type="primary" class="margin-top20" @click="addpant()"
          >立即申请</el-button
        >
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { entcopyrightapplysave } from "@/api/newhead/newhead.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      radio: "",
      table: [
        { name: "软件著作权", ite: 1 },
        { name: "作品版权", ite: 2 },
      ],
      input: "",
      input2: "",
      patent_type: "",
      patent: "",
      files: "",
      apply_date: "",
      contact: "",
      filename: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },

  methods: {
    onchange(val) {
      this.patent_type = val + 1;
    },
    // 版权申请
    addpant() {
      if (this.apply_date == "") {
        this.dialogVisiblenull = true;
        this.errormessage = "请选择申请时间";
      } else {
        entcopyrightapplysave({
          copyright_type: this.patent_type,
          software: this.patent,
          apply_date: this.apply_date,
          contact: this.contact,
        }).then((res) => {
          if (res.data.code == 200) {
            window.sessionStorage.setItem("onlineactiveName", "third");
            BUS.$emit("Applyfor", "yesss");
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    dialognull() {
      BUS.$emit("Applyfor", "yesno");
    },
  },
  components: {},
  created() {},
  updated() {},
};
</script>

<style scoped>
.stewardbox {
  width: 95%;
  margin: auto;
  padding: 20px 0 0 0;
}
.stewardtitle {
  font-size: 14px;
  color: #0039bf;
  text-align: center;
}
.patentapp {
  width: 100%;
  min-height: 100px;
  background: #f6f7fb;
  margin: 10px 0 0 0;
  padding: 0 0 20px 0;
  border-radius: 3px;
}
.radiogroup {
  padding: 20px 0 10px 30px;
}
.inputbox {
  width: 90%;
  margin: auto;
}
.dolwed {
  width: 40%;
  font-size: 14px;
  color: #52c5cb;
  line-height: 20px;
}
.input {
  margin: 10px 0 0 0;
}
.datepic {
  width: 100%;
}

.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>
